module.exports = __webpack_public_path__ + "img/ARCH_07.7a7ff094.jpg";